import { MarketplaceEntity } from '../../lib/api';
import { EntityCard } from './EntityCard';

interface EntityGridProps {
  entities: MarketplaceEntity[];
  loading?: boolean;
}

function EntityCardSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden animate-pulse">
      {/* Type header skeleton */}
      <div className="px-4 py-3 bg-gray-100 border-b">
        <div className="h-5 bg-gray-200 rounded w-24" />
      </div>
      <div className="p-4">
        <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-full mb-1" />
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-3" />
        <div className="flex items-center justify-between mb-2">
          <div className="h-6 bg-gray-200 rounded w-20" />
          <div className="h-4 bg-gray-200 rounded w-16" />
        </div>
        <div className="flex items-center justify-between">
          <div className="h-4 bg-gray-200 rounded w-16" />
          <div className="h-6 bg-gray-200 rounded w-12" />
        </div>
      </div>
    </div>
  );
}

export function EntityGrid({ entities, loading = false }: EntityGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-6">
        {[...Array(8)].map((_, i) => (
          <EntityCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (entities.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No entities found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-6">
      {entities.map((entity) => (
        <EntityCard key={entity.entityId} entity={entity} />
      ))}
    </div>
  );
}
